import * as yup from 'yup';

import { ValidationError } from 'src/enums/Validation';
import { decimalHoursSchema } from 'src/forms/decimalHours';
import { CreateParams } from 'src/repositories/organizationAdmin/TimeSheetsAdjustmentsRepository';
import { NestedTimeSheet } from 'src/types/resources/TimeSheet';
import { getMaxFieldLengthErrorMessage } from 'src/utils/validation';

export type OrgTimeSheetAdjustmentFormData = {
  hours: string;
  clientComment: string;
};

export const validationSchema = yup.object({
  hours: decimalHoursSchema,
  clientComment: yup
    .string()
    .trim()
    .max(500, getMaxFieldLengthErrorMessage(500))
    .required(ValidationError.default)
    .label('Description'),
});

export const initialValues = (timeSheet: NestedTimeSheet): OrgTimeSheetAdjustmentFormData => ({
  hours: timeSheet.hours,
  clientComment: '',
});

export const attributesToSubmit = (parentId: ID, values: OrgTimeSheetAdjustmentFormData): CreateParams => {
  const { hours, clientComment } = values;

  return {
    parentId,
    hours,
    clientComment: clientComment.trim(),
  };
};
